import { ChangeDetectorRef, Component, inject, OnInit, ViewEncapsulation, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { MyReservationService } from '../../shared/services/my-reservation.service';
import { MatDialog } from '@angular/material/dialog';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { NgOptimizedImage } from '@angular/common';
import {
  ID_LOGIN_TYPE,
  IMAGE_DEPT_NAME,
  LINE_URL,
} from '../../shared/constants/common.constants';
import { SharedStorageService } from '../../shared/services/shared-storage.service';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { SingleActionDialogComponent } from '../../shared/components/dialogs/single-action-dialog/single-action-dialog.component';
import { DevService } from '../../shared/services/dev.service';
import {
  HealthCheckPlanResponse,
  Reminder,
  ReminderItem,
  PackageGroup,
  PackageInfo,
  PlanListItem,
  ExamItem,
  BookingInfo,
  ImageBookData,
  OptionItem,
} from '../../shared/interfaces/my-reservation.model';
import { NumberCommaPipe } from '../../pipes/number-comma.pipe';
import { API_PARAMS } from '../../shared/constants/api.constants';
import { ExamItemName } from '../../shared/interfaces/reserve-confirm-survey.model';
import { DuoActionDialogComponent } from '../../shared/components/dialogs/duo-action-dialog/duo-action-dialog.component';
import { TwDatePipe } from '../../pipes/tw-date.pipe';
import { FormatDatePipe } from '../../pipes/format-date.pipe';
import {
  MatButtonToggle,
  MatButtonToggleGroup,
} from '@angular/material/button-toggle';
import { ToastrService } from 'ngx-toastr';
import { BusinessExamInfo, ExamInfo } from '../../shared/interfaces/reserve-loading.model';
import { AddExamInfo } from '../../shared/interfaces/reserve-add.model';
import { IdleTimeoutService } from '../../shared/services/idle-timeout.service';
import { DownloadPlanRequest } from '../../shared/interfaces/download-plan.model';
import { DownloadPlanService } from '../../shared/services/download-plan.service';
import moment from 'moment';
import { filenameFromContentDisposition } from '../../shared/utils/file-decode.utils';


/**
 * 會員中心我的預約組件
 */
@Component({
  selector: 'app-appointment-complete',
  standalone: true,
  imports: [
    TranslatePipe,
    MatButton,
    NgOptimizedImage,
    NumberCommaPipe,
    MatIconButton,
    MatButtonToggleGroup,
    MatButtonToggle,
  ],
  templateUrl: './appointment-complete.component.html',
  styleUrl: './appointment-complete.component.scss',
  // encapsulation: ViewEncapsulation.None,
})
export class AppointmentCompleteComponent implements OnInit {
  myReservationService: MyReservationService = inject(MyReservationService);
  sharedStorageService: SharedStorageService = inject(SharedStorageService);
  translateService: TranslateService = inject(TranslateService);
  downloadPlanService: DownloadPlanService = inject(DownloadPlanService);
  authService: AuthService = inject(AuthService);
  devService: DevService = inject(DevService);
  dialog: MatDialog = inject(MatDialog);
  router: Router = inject(Router);
  toastr: ToastrService = inject(ToastrService);

  twDatePipe: TwDatePipe = new TwDatePipe();
  formatDatePipe: FormatDatePipe = new FormatDatePipe();

  protected readonly Number = Number;

  flowCode: string = ''; // 預約執行流程代號
  idNo: string = ''; // 身分證字號
  caseNo: string = ''; // 健檢編號
  chartNo: string = ''; // 病歷號
  name: string = ''; // 姓名
  birthday: string = ''; // 生日
  gender: string = ''; // 性別
  healthCheckPlan?: HealthCheckPlanResponse; // 健檢方案
  diffDays: number = 0; // 目前時間與預約時間相差天數

  activeReminders = new Set<ReminderItem>(); // 切換提醒是否收合

  showFullExamInfos: boolean = false; // 是否顯示完整檢項資訊
  selectedPackage: string = ''; // 選擇的健檢方案

  examNameGroupByDeptName: Map<string, string[]> = new Map<string, string[]>(); // 健檢項目依照科別分組
  addExamNameList: Array<string> = []; // 加選檢查名稱列表

  isShowSponsorAmt: boolean = false; // 是否顯示企業補助金額(來自API)
  isShowPrice: boolean = false; // 是否顯示企業套檢金額(來自API)
  healthCheckTime: string = ''; // 健檢時間
  nutritionConsultationTime: string = ''; // 營養諮詢時間
  isShowNutrition:boolean = true;//是否顯示營養諮詢
  imageItems: Array<{ imageExamName: string; imageBookDateTime: string }> = []; // 高階影像檢查項目名稱列表
  orgName: string = ''; // 健檢中心名稱
  
  reportLanguageNoDesc: string = ''; // 檢查報告語言NODESC
  reportLanguageUno: string = ''; // 檢查報告語言UNO
  clothesSizeNoDesc: string = ''; // 健檢服尺寸NODESC
  clothesSizeUno: string = ''; // 健檢服尺寸UNO
  breakfastNoDesc: string = ''; // 早餐選項NODESC
  breakfastUno: string = ''; // 早餐選項UNO
  lunchNoDesc: string = ''; // 午餐選項NODESC
  lunchUno: string = ''; // 午餐選項UNO

  contactAddress: string = ''; // 檢前資料地址(完整)
  contactZipCode: string = ''; // 檢前資料地址的郵遞區號

  reportAddress: string = '';// 檢查報告地址(完整)
  reportZipCode: string = ''; // 檢後報告地址的郵遞區號
  examReportAddress: string = ''; //html顯示:國內/國外+檢後地址

  recipient: string = ''; // 收件人姓名
  recipientCell: string = ''; // 收件人手機號碼
  isShowRecipientCell: boolean = false; // 是否顯示收件人手機號碼
  // deptName是否展開 { deptName: isOpen }
  isDeptNameOpen: Map<string, boolean> = new Map();

  ngOnInit(): void {
    
    // 取得登入信息(身分證字號、生日、姓名、病例號)
    this.idNo = this.sharedStorageService.get('createMemberRequest')?.idNo ?? '';
    this.chartNo = this.sharedStorageService.get('createMemberRequest')?.chartNo ?? '';
    this.name = this.sharedStorageService.get('createMemberRequest')?.name ?? '';
    this.gender = this.sharedStorageService.get('createMemberRequest')?.gender ?? '';
    this.birthday = this.sharedStorageService.get('createMemberRequest')?.birthday ?? '';
    this.birthday = this.formatDatePipe.transform(this.birthday);
    
          // 已有預約資料(呼叫CB-007)，初始化預約資料
          this.myReservationService
            .getHealthCheckPlan(this.chartNo, this.idNo)
            .subscribe(res => {

              this.healthCheckPlan = res.data;
              console.log('healthCheckPlan', this.healthCheckPlan);
              this.caseNo = this.healthCheckPlan?.bookData.caseNo ?? '';
              console.log('caseNo', this.healthCheckPlan?.bookData.caseNo);
              if (this.healthCheckPlan?.reminderList[0]) {
                this.activeReminders.add(
                  this.healthCheckPlan?.reminderList[0]
                ); // 預設展開第一組提醒
              }
              this.selectedPackage =
                this.healthCheckPlan?.packageGroup.packageName ?? '';

              // 取得檢項
              this.healthCheckPlan?.packageGroup.packageInfo.planList.forEach(
                (pkg: PlanListItem) => {
                  this.isDeptNameOpen.set(pkg.deptName, false); // 初始化deptName展開狀態

                  // 取得現有的檢查項目列表,如果不存在則建立空陣列
                  const existingExamNames = this.examNameGroupByDeptName.get(pkg.deptName) ?? [];

                  // 從當前檢項中提取檢查項目名稱
                  const newExamNames = pkg.examItemList.map(exam => exam.examName);

                  // 使用 Set 去除重複項目,然後轉回陣列
                  const uniqueExamNames = Array.from(new Set([...existingExamNames, ...newExamNames]));

                  if (this.healthCheckPlan?.dataType === '2') {
                    this.isShowSponsorAmt = this.healthCheckPlan?.isShowSponsorAmt ?? false;
                    this.isShowPrice = this.healthCheckPlan?.isShowPrice ?? false;
                  }

                  this.examNameGroupByDeptName.set(pkg.deptName, uniqueExamNames);
                }
              );

              // 取得加選檢項 - 使用 Set 去除重複項目
              const newAddExamNames = this.healthCheckPlan?.packageGroup.packageInfo.addList.map(
                (examItemName: ExamItemName) => examItemName.examName
              ) ?? [];

              // 合併現有和新的加選項目,並去除重複
              this.addExamNameList = Array.from(new Set([...this.addExamNameList, ...newAddExamNames]));

              // 取得健檢時間
              const bookDate = this.healthCheckPlan?.bookData.bookDate;
              const bookTime = this.healthCheckPlan?.bookData.bookTime;
              const bookingDateTimeText =
                Number(bookTime) < 1200
                  ? this.translateService.instant('my-reservation.morning')
                  : this.translateService.instant('my-reservation.afternoon');
              this.healthCheckTime =
                this.twDatePipe.transform(bookDate ?? '') +
                ' ' +
                bookingDateTimeText +
                bookTime?.replace(/^(\d{2})(\d{2})$/, '$1:$2');
                
              // 取得營養諮詢時間
              const nutBookDate =
                this.healthCheckPlan?.bookData.nutBookDate;
                const nutBookTime =
                this.healthCheckPlan?.bookData.nutBookTime;
                if(!nutBookDate || nutBookDate.trim() === ''){
                  this.isShowNutrition = false;
                }
              const nutBookingDateTimeText =
                nutBookTime ?
                Number(nutBookTime) < 1200
                  ? this.translateService.instant('my-reservation.morning')
                  : this.translateService.instant('my-reservation.afternoon')
                : ''  ;
              this.nutritionConsultationTime =
                this.twDatePipe.transform(nutBookDate ?? '') +
                ' ' +
                nutBookingDateTimeText +
                nutBookTime?.replace(/^(\d{2})(\d{2})$/, '$1:$2');

                console.log('nutritionConsultationTime:',this.nutritionConsultationTime);

              // 取得高階影像檢查項目名稱列表
              this.imageItems=
              this.healthCheckPlan?.bookData.imageBookDataList
                .map(item => {
                  if (item.imageBookDate && item.imageBookTime) {
                    // 解析 imageBookTime，可能包含註解文字
                    const timeMatch = item.imageBookTime.match(/^(\d{4})(.*)$/);
                    const timeOnly = timeMatch ? timeMatch[1] : '';
                    const noteText = timeMatch ? timeMatch[2] : '';

                    let timeDisplay = '';
                    if (timeOnly) {
                      // 有四位數字時，顯示上午/下午和格式化時間
                      //imageBookDateTime: "1200我是測試"->轉成"下午12:00我是測試"
                      const periodText = Number(timeOnly) < 1200
                        ? this.translateService.instant('my-reservation.morning')
                        : this.translateService.instant('my-reservation.afternoon');
                      const formattedTime = timeOnly.replace(/^(\d{2})(\d{2})$/, '$1:$2');
                      timeDisplay = periodText + formattedTime + noteText;
                    } else {
                      // 沒有四位數字時，直接顯示原始文字
                      //imageBookDateTime: "我是測試"->轉成"我是測試"(不顯示上午/下午)
                      timeDisplay = item.imageBookTime;
                    }
                    timeDisplay = item.imageBookHospital ? item.imageBookHospital + ' ' + timeDisplay : timeDisplay;
                    
                    return {
                      imageExamName: item.imageExamName,
                      imageBookDateTime: this.twDatePipe.transform(item.imageBookDate) + ' ' + timeDisplay
                    };
                    
                    
                  } else {
                    return {
                      imageExamName: item.imageExamName,
                      imageBookDateTime: this.translateService.instant('my-reservation.someone-call-to-confirm-time')
                    };
                  }
                }) ?? [];

              // 取得健檢中心名稱
              this.orgName = `${this.healthCheckPlan?.bookData.orgName} (${this.healthCheckPlan?.bookData.orgAddress})`;
              
              const bookData = this.healthCheckPlan?.bookData;
              //取得檢前資料地址
              this.contactAddress = bookData?.contactAddress ?? '';
              // 取得檢查報告地址
              this.reportAddress = bookData?.deliveryAddress ?? '';
              if (
                bookData?.deliveryType ===
                API_PARAMS.DELIVERY_METHOD.DOMESTIC.code
              ) {
                this.examReportAddress =
                  API_PARAMS.DELIVERY_METHOD.DOMESTIC.name +
                  "<span class='doc-divider'>・</span>" +
                  this.reportAddress;
              } else if (
                bookData?.deliveryType ===
                API_PARAMS.DELIVERY_METHOD.FOREIGN.code
              ) {
                this.examReportAddress =
                  API_PARAMS.DELIVERY_METHOD.FOREIGN.name +
                  "<span class='doc-divider'>・</span>" +
                  this.reportAddress;
              }

              //取得收件人資料
              this.recipient= bookData?.recipient??'無';
              this.recipientCell = bookData?.recipientCell??'無';
              //判斷收件人資料是否非本人
              if(this.recipient === this.name){
                this.isShowRecipientCell = false;
              }else{
                //若非本人則顯示收件人電話
                this.isShowRecipientCell = true;
              }
              console.log("this.isShowRecipientCell:",this.isShowRecipientCell);

              // 取得檢查報告語言
              this.reportLanguageNoDesc =
                this.healthCheckPlan?.bookData?.language.noDesc ?? '';
                console.log("this.reportLanguageNoDesc:",this.reportLanguageNoDesc);
                console.log("this.reportLanguageUno:",this.reportLanguageUno);

              // 取得健檢服尺寸
              this.clothesSizeNoDesc =
                this.healthCheckPlan?.bookData?.clothesSize.noDesc ?? '';

              // 取得早餐選項
              this.breakfastNoDesc =
                this.healthCheckPlan?.bookData?.breakfast.noDesc ?? '';

              // 取得午餐選項
              this.lunchNoDesc = this.healthCheckPlan?.bookData?.lunch.noDesc ?? '';

              const myReservation={
                        flowCode :'4',
                        bookStatus :this.healthCheckPlan?.bookStatus??'',
                        diffDates :0,
                        bookDate :this.healthCheckPlan?.bookData.bookDate??'',
                        caseNo :this.caseNo ??'',
                        companyNo:this.healthCheckPlan?.bookData.companyNo ?? '',
                        familyFlag:this.healthCheckPlan?.bookData.familyFlag ?? '',
                      }
              this.sharedStorageService.set('myReservation', myReservation);

              //打完CB-007再清
              this.sharedStorageService.clear();
            });
  }
  // 是否為個人健檢
  get isPersonal(): boolean {
    return this.healthCheckPlan?.dataType === '1';
  }

  // 檢查企業補助金額是否大於0
  get hasSponsorAmt(): boolean {
    const sponsorAmt = this.healthCheckPlan?.packageGroup?.sponsorAmt;
    console.log("轉數字sponsorAmt:",Number(sponsorAmt));
    return sponsorAmt ? Number(sponsorAmt) > 0 : false;
  }

  // 切換提醒是否收合
  toggleReminderActive(reminder: ReminderItem): void {
    if (this.activeReminders.has(reminder)) {
      this.activeReminders.delete(reminder);
    } else {
      this.activeReminders.add(reminder);
    }
  }

  // 檢查提醒是否收合
  isReminderActive(reminder: ReminderItem): boolean {
    return this.activeReminders.has(reminder);
  }

  // 切換顯示全部檢項
  toggleShowFullExamInfos(): void {
    this.showFullExamInfos = !this.showFullExamInfos;
  }

  // 取得健檢時間類型
  getDayTypeText(dayType?: string): string {
    return dayType === API_PARAMS.DAY_TYPE.HALF_DAY.code
      ? API_PARAMS.DAY_TYPE.HALF_DAY.name
      : API_PARAMS.DAY_TYPE.FULL_DAY.name;
  }

  // 取得方案內檢項資訊
  getExamInfoByName(examName: string): ExamInfo | AddExamInfo | BusinessExamInfo {
    const planExamInfo = this.healthCheckPlan?.packageGroup.packageInfo.planList
      .flatMap((pkg: PlanListItem) => pkg.examItemList)
      .find((exam: ExamItem) => exam.examName === examName);
    if (planExamInfo) {
      return planExamInfo as ExamInfo;
    }
    const addExamInfo = this.healthCheckPlan?.packageGroup.packageInfo.addList.find(
      (exam: ExamItemName) => exam.examName === examName
    );
    if (addExamInfo) {
      return {
        examName: addExamInfo.examName,
        examItem: addExamInfo.examItem,
        examMemo: addExamInfo.examMemo ?? '',
        price: addExamInfo.examPrice,
      }
    }
    return {} as ExamInfo;
  }

// 顯示檢項dialog
  showExamDialog(examInfo: ExamInfo | AddExamInfo | BusinessExamInfo) {
    const examDialog = this.dialog.open(SingleActionDialogComponent, {
      data: {
        title: examInfo.examName,
        message: examInfo.examMemo,
        buttonText: this.translateService.instant('common.button.i-understood'),
        showCloseButton: false,
        action: () => examDialog.close(),
      },
    });
  }

  //導轉到LINE
  handleToLine(): void {
    window.open(LINE_URL, '_blank');
  }

  // 下載一般方案比較表
  downloadPlan() {
    const request: DownloadPlanRequest = {
      orgNo: this.healthCheckPlan?.bookData?.orgNo ?? '',
      caseNo: Number(this.caseNo) ?? 0,
    }
    this.downloadPlanService.downloadPlan(request).subscribe({
      next: (resp) => {
        const blob = resp.body as Blob;
        const cd = resp.headers.get('content-disposition');
        
        // 解析檔名
        let fileName = filenameFromContentDisposition(cd);
        if (!fileName) {
          fileName = `${moment().format('YYYYMMDD')}-預約完成健檢方案-${this.orgName}.pdf`;
        }

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      error: async (err) => {
        console.error('下載 API 發生錯誤:', err);
        // 將 Blob 轉換為 JSON 以取得 errorMessage
        let errorMessage = '下載失敗,請稍後再試';
        if (err.error instanceof Blob) {
          try {
            const text = await err.error.text();
            const errorObj = JSON.parse(text);
            errorMessage = errorObj.errorMessage || errorMessage;
          } catch (parseError) {
            console.error('解析錯誤訊息失敗:', parseError);
          }
        } else if (err.error?.errorMessage) {
          errorMessage = err.error.errorMessage;
        }
        this.toastr.error(errorMessage);
      }
    });
  }
  protected readonly API_PARAMS = API_PARAMS;

}
